module.exports = __webpack_public_path__ + "fonts/founders-grotesk-medium.029374a.woff2";